import React from 'react';
import styles from './PilgrimageTourSection.module.css';

const PilgrimageTourSection = () => {
  return (
    <section className={styles.container}>
       <div className={styles.overlay}></div>
       <div className={styles.content}>
            <p className={styles.date} style={{ color: 'white' }}>SAT, 12TH MAY AT 10:00 AM</p>
            <h2 className={styles.title} style={{ color: 'white' }}>
                Shravani Mela of Deoghar  <span className={styles.subtitle}>A Sacred Pilgrimage of Devotion</span>
            </h2>
            <div className={styles.footer}>
                <p className={styles.location}>Deoghar,Jharkhand</p>
               
            </div>
       </div>
    </section>
  );
};

export default PilgrimageTourSection;